export default __webpack_public_path__ + "static/media/no-grades.b8de2868.svg";